<template>
    <div class="shopping-present-success">
        <p>{{ result }}</p>
    </div>
</template>

<script>
export default {
    name: 'ShoppingPresentSuccess',
    props: ['result'],
}
</script>

<style lang="scss" scoped>
.shopping-present-success{
    text-align: center;
    font-weight: 500;
    font-size: 20px;
        color: var(--text-colour-secondary);
}
</style>